import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Typography, Space, Divider, Tag, Avatar } from 'antd';
import { DownOutlined, UpOutlined, EditOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import Loader from '../ReusableComponents/Loader';
import { toastError, toastWarn } from '../Toast/ToastComponent';
import { TrainingsApi } from '../../Api/TrainingsApi';
import AttendancePopup from './AttendancePopup';
import { useAuth } from '../../Context/AuthContext';

const { Text } = Typography;
const TrainingsAttendance = () => {
  const { authState } = useAuth();
  const location = useLocation();
  const [expandedRow, setExpandedRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [attendanceData, setAttendanceData] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState(null);
  const training_id =
    location?.state?.training_id ||
    location?.state?.overviewData?.training_details?.id;
  useEffect(() => {
    if (training_id) {
      getAttendance();
    }
  }, [training_id]);
  const getAttendance = async () => {
    try {
      setLoading(true);
      const payload = {
        training_id: training_id,
        user_id: authState?.id,
      };
      const res = await TrainingsApi.getOverallAttendance(payload);
      if (res?.data?.success) {
        setAttendanceData(res?.data?.result || []);
      } else {
        toastWarn(res?.data?.message || 'No attendance found');
      }
    } catch (err) {
      toastError(err?.response?.data?.message || err?.message);
    } finally {
      setLoading(false);
    }
  };
  const toggleExpand = (day) => {
    setExpandedRow(expandedRow === day ? null : day);
  };
  const handleEditClick = async (e, item) => {
    e.stopPropagation();
    try {
      const payload = {
        training_id: training_id,
        session_date: item.session_date,
      };
      const res = await TrainingsApi.getDayWiseAttendance(payload);
      if (res?.data?.success) {
        setSelectedAttendance(res?.data?.result);
        setShowEditPopup(true);
      } else {
        toastWarn(res?.data?.message || 'Failed to fetch day-wise attendance');
      }
    } catch (err) {
      toastError(err?.response?.data?.message || err?.message);
    }
  };
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB');
  };
  return (
    <div
      style={{
        background: '#f0f2f5',
        minHeight: '100vh',
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          {attendanceData.map((item) => {
            const trainers =
              item?.attendance_details?.filter((x) => x.role === 'trainer') ||
              [];

            const trainees =
              item?.attendance_details?.filter((x) => x.role === 'trainee') ||
              [];

            return (
              <Card
                key={item.day}
                hoverable
                onClick={() => toggleExpand(item.day)}
                onMouseEnter={() => setHoveredRow(item.day)}
                onMouseLeave={() => setHoveredRow(null)}
                style={{
                  marginBottom: 12,
                  borderRadius: 4,
                  border: 'none',
                  overflow: 'hidden',
                }}
                bodyStyle={{ padding: 0 }}
              >
                <div
                  style={{
                    padding: '16px 24px',
                  }}
                >
                  <Row align="middle">
                    <Col span={2}>
                      <div
                        style={{
                          width: 50,
                          height: 50,
                          backgroundColor: '#1890ff',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          fontWeight: 500,
                        }}
                      >
                        Day {item.day}
                      </div>
                    </Col>
                    <Col span={20}>
                      <Space
                        direction="vertical"
                        size={0}
                        style={{
                          width: '100%',
                        }}
                      >
                        <Space size="middle">
                          <Text
                            strong
                            style={{
                              fontSize: 18,
                            }}
                          >
                            {formatDate(item.session_date)}
                          </Text>

                          <Divider
                            type="vertical"
                            style={{
                              height: 20,
                            }}
                          />
                          <Text type="secondary">Start & End Time :</Text>
                          <Text strong>
                            {item.check_in_time || '--'} -{' '}
                            {item.check_out_time || '--'}
                          </Text>
                        </Space>

                        <div
                          style={{
                            marginTop: 4,
                          }}
                        >
                          <Space
                            size="large"
                            split={<Divider type="vertical" />}
                          >
                            <Text type="secondary">
                              Trainers: <Text strong>{item.trainer_count}</Text>
                            </Text>

                            <Text type="secondary">
                              Trainees: <Text strong>{item.trainee_count}</Text>
                            </Text>

                            {Number(item.present_count || 0) > 0 && (
                              <Text type="secondary">
                                Present:{' '}
                                <Text
                                  strong
                                  style={{
                                    color: '#52c41a',
                                  }}
                                >
                                  {item.present_count}
                                </Text>
                              </Text>
                            )}
                            {Number(item.absent_count || 0) > 0 && (
                              <Text type="secondary">
                                Absent:{' '}
                                <Text
                                  strong
                                  style={{
                                    color: '#ff4d4f',
                                  }}
                                >
                                  {item.absent_count}
                                </Text>
                              </Text>
                            )}
                          </Space>
                        </div>
                      </Space>
                    </Col>
                    <Col
                      span={2}
                      style={{
                        textAlign: 'right',
                      }}
                    >
                      {hoveredRow === item.day &&
                        new Date(item.session_date).setHours(0, 0, 0, 0) <=
                          new Date().setHours(0, 0, 0, 0) && (
                          <EditOutlined
                            style={{
                              marginRight: 16,
                              fontSize: 16,
                              color: '#1890ff',
                            }}
                            onClick={(e) => handleEditClick(e, item)}
                          />
                        )}
                      {expandedRow === item.day ? (
                        <UpOutlined />
                      ) : (
                        <DownOutlined />
                      )}
                    </Col>
                  </Row>
                </div>
                {expandedRow === item.day && (
                  <div
                    style={{
                      padding: '20px 24px',
                      background: '#fff',
                      borderTop: '1px solid #f0f0f0',
                    }}
                  >
                    <Row gutter={[16, 16]}>
                      {trainers.map((trainer) => (
                        <Col key={trainer.user_id}>
                          <Card
                            size="small"
                            style={{
                              borderRadius: 8,
                            }}
                          >
                            <Space>
                              <Avatar
                                style={{
                                  backgroundColor: '#1890ff',
                                }}
                              >
                                {trainer.username?.charAt(0)?.toUpperCase()}
                              </Avatar>
                              <Space direction="vertical" size={0}>
                                <Text strong>{trainer.username}</Text>
                                <Text
                                  type="secondary"
                                  style={{
                                    fontSize: 11,
                                  }}
                                >
                                  {trainer.check_in_time || '--'} -{' '}
                                  {trainer.check_out_time || '--'}
                                </Text>
                              </Space>
                              <Text
                                style={{
                                  color: '#1890ff',
                                  fontSize: 12,
                                }}
                              >
                                TRAINER
                              </Text>
                            </Space>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                    <div
                      style={{
                        margin: '20px 0 10px 0',
                      }}
                    >
                      <Text type="secondary">Trainees</Text>

                      <Divider
                        style={{
                          margin: '8px 0',
                        }}
                      />
                    </div>
                    <Row gutter={[16, 16]}>
                      {trainees.map((trainee) => (
                        <Col key={trainee.user_id} span={8}>
                          <Card
                            size="small"
                            style={{
                              borderRadius: 8,
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <Space>
                                <Avatar
                                  style={{
                                    backgroundColor:
                                      trainee.status === 'present'
                                        ? '#52c41a'
                                        : '#ff4d4f',
                                  }}
                                >
                                  {trainee.username?.charAt(0)?.toUpperCase()}
                                </Avatar>

                                <Text>{trainee.username}</Text>
                              </Space>

                              {(trainee.status === 'present' ||
                                (trainee.status === 'absent' &&
                                  Number(item.present_count || 0) +
                                    Number(item.absent_count || 0) >
                                    0)) && (
                                <Tag
                                  color={
                                    trainee.status === 'present'
                                      ? 'green'
                                      : 'red'
                                  }
                                  style={{
                                    margin: 0,
                                  }}
                                >
                                  {trainee.status?.toUpperCase()}
                                </Tag>
                              )}
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                )}
              </Card>
            );
          })}
          {showEditPopup && (
            <AttendancePopup
              visible={showEditPopup}
              onClose={() => {
                setShowEditPopup(false);
                setSelectedAttendance(null);
                getAttendance();
              }}
              attendanceData={selectedAttendance}
            />
          )}
        </>
      )}
    </div>
  );
};
export default TrainingsAttendance;
